// extracted by mini-css-extract-plugin
export var closeButton = "_nm-1";
export var closeX = "_nm-3";
export var container = "_nm-0";
export var image = "_nm-2";